<template>
    <div v-if="content.hasOwnProperty('id')" class="container is-max-desktop">
        <h1>{{ content.headline != '' ? content.headline : content.name }}</h1>
        <div v-html="content.abstract" class="abstract"></div>
        <div v-html="content.text" class="text"></div>
    </div>
</template>

<script>
import ax from 'axios'
export const axios = ax

import { defineComponent } from 'vue'
import { useComposition } from '@/compositions/composition'

export default defineComponent({
    setup() {
        const { global } = useComposition();

        return {
            global
        }
    },
    data() {
        return {
            content: {}
        }
    },
    created() {
        if (this.$route.path != '/login') {
            this.contentLoad();
        }

    },
    methods: {
        contentLoad() {
            const path = this.$route.path == '/' ? '/' : this.$route.path;
            axios.get(`${process.env.VUE_APP_API_ROOT}/cms-content.json`)
                .then(response => {
                    const contentMap = response.data.content || {};
                    this.content = contentMap[path] || {};
                    if (this.content.browserTitle) {
                        document.title = this.content.browserTitle;
                    }
                    if (this.content.metaDescription) {
                        const meta = document.querySelector('meta[name="description"]');
                        if (meta) {
                            meta.setAttribute("content", this.content.metaDescription);
                        }
                    }
                })
        }
    },
    computed: {
        currentRoute() {
            return this.$route;
        }
    }
})
</script>